<template>
  <lv-button
    styling="small-secondary-dark"
    shrink
    :aria-label="ariaLabel"
    :aria-expanded="modelValue"
    @click="$emit('update:modelValue', !modelValue)"
  >
    <span :class="$style.expandBtnContent">
      <span v-text="text" />
      <lv-icon
        name="arrow-up-16"
        :size="16"
        :class="{
          [$style.expandBtnIcon]: !modelValue,
        }"
      />
    </span>
  </lv-button>
</template>
<script setup>
  import { LvButton, LvIcon } from '~~/common/components/loginet-vue-shop/index';

  const props = defineProps({
    modelValue: {
      type: Boolean,
      required: true,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    referenceId: {
      type: String,
      required: true,
    },
    closedHeight: {
      type: String,
      required: true,
    },
  });

  defineEmits(['update:modelValue']);

  watch(() => props.modelValue, (newVal) => {
    const el = document.getElementById(props.referenceId);
    if (el) {
      const scrollHeight = el.scrollHeight + 'px';
      const openCloseAnimation = [
        { height: scrollHeight },
        { height: props.closedHeight },
      ];
      if (newVal) {
        openCloseAnimation.reverse();
      }
      const openCloseAnimationTiming = {
        duration: 320,
        fill: 'forwards',
      };
      const animation = el.animate(openCloseAnimation, openCloseAnimationTiming);
      animation.finished.then(() => {
        if (newVal) {
          el.style.height = 'initial';
        } else {
          animation.commitStyles();
        }
        animation.cancel();
      });
    }
  });
</script>
<style module lang="scss" rel="stylesheet/scss">
.expandBtnContent {
  display: flex;
  gap: 8px;
}

.expandBtnIcon {
  rotate: 180deg;
}
</style>
